import { Controller } from "@hotwired/stimulus"

// Repositions dropdown menu with fixed positioning so it escapes overflow containers
// (e.g. tables with overflow-x-auto). Use alongside railsui-dropdown.
export default class extends Controller {
  static values = { offset: { type: Number, default: 8 } }

  connect() {
    this.trigger = this.element.querySelector("button")
    this.menu = this.element.querySelector("[data-railsui-dropdown-target='menu']")
    if (!this.trigger || !this.menu) return

    this.observer = new MutationObserver(() => this.syncPosition())
    this.observer.observe(this.menu, { attributes: true, attributeFilter: [ "class" ] })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  syncPosition() {
    if (this.menu.classList.contains("hidden")) {
      this.menu.style.position = ""
      this.menu.style.top = ""
      this.menu.style.right = ""
      this.menu.style.left = ""
      return
    }

    requestAnimationFrame(() => {
      const rect = this.trigger.getBoundingClientRect()
      const offset = this.offsetValue

      this.menu.style.position = "fixed"
      this.menu.style.top = `${rect.bottom + offset}px`
      this.menu.style.right = `${window.innerWidth - rect.right}px`
      this.menu.style.left = "auto"
    })
  }
}
